// VJ Rider (M15-F3 / F4, DC-62 / DC-63 / DC-65): the phone screens a Rider opens at /rider in the Sales App.
// Not a Sales App menu: the Rider signs in with the Rider pool mobile + OTP and sees only the
// CRM 2.0 registrations tagged to them, in Today · Upcoming · Not Done. No price or payments.
//   /rider                    sign-in, then the three tabs
//   /rider/:slotBookingId     the registration page, with the one action Mark Registration Done
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { Box, Modal } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  riderToken, saveRiderToken, clearRiderToken, askSignInOtp, verifySignInOtp, getRegistrations, getRegistration, markRegistrationDone, riderError,
} from "../../Services/RiderApp";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DesktopDatePickerComponent from "../../Subcomponents/DesktopDatePicker";
import Close from "../../Components/Icons/Close";
import { successTost } from "../../Services/Toast";
import strip2 from "../../Assets/Images/Login/strip2.svg";
import strip3 from "../../Assets/Images/Login/strip3.svg";
import logo from "../../Assets/Images/SideMenu/vjLogo.jpg";
// the sign-in uses the Sales App login page's layout (background, strips, card)
import loginCss from "../../Components/Login/Login.module.css";
import css from "./RiderApp.module.css";
// the Mark Registration Done pop-up uses the CRM Agreement Done pop-up's styles
import modalCss from "../../Components/AllAllotments/CrmAllotment/AgreementDoneModal/AgreementDoneModal.module.css";

const TABS = [["today", "Today"], ["upcoming", "Upcoming"], ["notDone", "Not Done"]];
const HALF = { 1: "1st half", 2: "2nd half" };
const todayKey = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
const keyDay = (key) => new Date(`${key}T00:00:00+05:30`).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric" });
const niceDay = (ms) => new Date(Number(ms)).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", weekday: "short", day: "numeric", month: "short", year: "numeric" });

function SignIn({ onSignedIn }) {
  const [mobile, setMobile] = useState("");
  const [challenge, setChallenge] = useState(null);
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [wait, setWait] = useState(0);

  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait(wait - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  async function sendOtp() {
    setBusy(true);
    setError("");
    try {
      const c = await askSignInOtp(mobile);
      setChallenge(c);
      setOtp("");
      setWait(c.resendAfterSeconds || 30);
    } catch (err) {
      setError(riderError(err).message);
    } finally {
      setBusy(false);
    }
  }

  async function verify() {
    setBusy(true);
    setError("");
    try {
      const session = await verifySignInOtp(challenge.challengeId, otp);
      saveRiderToken(session);
      onSignedIn(session);
    } catch (err) {
      setError(riderError(err).message);
    } finally {
      setBusy(false);
    }
  }

  const mobileOk = mobile.replace(/\D/g, "").length >= 10;
  return (
    <div className={loginCss.wrapperPage} style={{ height: "100vh" }}>
      <div className={loginCss.backgroundImage}>
        <img src={strip2} className={loginCss.strip2} alt="" />
        <img src={strip3} className={loginCss.strip3} alt="" />
        <div className={loginCss.registerationBlock}>
          <div><img src={logo} style={{ width: "23rem", maxWidth: "100%" }} alt="VJ" /></div>
          <div>
            <div className={css.signInTitle}>VJ Rider</div>
            <div className={css.signInSub}>
              {!challenge ? "Sign in with your registered mobile number" : `Enter the ${challenge.digits}-digit OTP sent to ${challenge.maskedMobile}`}
            </div>
          </div>
          {!challenge ? (
            <div style={{ textAlign: "left" }}>
              <CustomInput label="Mobile number" mandatory value={mobile} max={14} placeholder="Enter your mobile number" inputType="label"
                handleChange={(v) => setMobile(v.replace(/[^\d+ ]/g, ""))}
                onKeyPress={(e) => e.key === "Enter" && mobileOk && !busy && sendOtp()} />
            </div>
          ) : (
            <div style={{ textAlign: "left" }}>
              <CustomInput label="OTP" mandatory value={otp} max={challenge.digits} placeholder={`Enter the ${challenge.digits}-digit OTP`} inputType="label"
                handleChange={(v) => setOtp(v.replace(/\D/g, ""))}
                onKeyPress={(e) => e.key === "Enter" && otp.length === challenge.digits && !busy && verify()} />
            </div>
          )}
          {error && <div className={css.error} role="alert" style={{ textAlign: "left" }}>{error}</div>}
          <div>
            {!challenge ? (
              <Button style={{ color: "#ffffff", backgroundColor: "#1570EF" }} btnName="Get OTP" clicked={sendOtp} isLoading={busy} disable={busy || !mobileOk} />
            ) : (
              <Button style={{ color: "#ffffff", backgroundColor: "#1570EF" }} btnName="Sign in" clicked={verify} isLoading={busy} disable={busy || otp.length !== challenge.digits} />
            )}
          </div>
          {challenge && (
            <div className={css.row}>
              <button type="button" className={css.link} onClick={() => { setChallenge(null); setError(""); }}>Change number</button>
              <button type="button" className={css.link} disabled={busy || wait > 0} onClick={sendOtp}>{wait > 0 ? `Resend OTP in ${wait}s` : "Resend OTP"}</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// White top bar with the VJ logo, as the Sales App header
function TopBar({ name, onSignOut }) {
  return (
    <header className={css.topBar}>
      <img src={logo} className={css.logo} alt="VJ" />
      <div className={css.topRight}>
        <span className={css.who}>{name}<span className={css.muted}> · Rider</span></span>
        <button type="button" className={css.link} onClick={onSignOut}>Sign out</button>
      </div>
    </header>
  );
}

function Card({ r, onOpen }) {
  return (
    <button type="button" className={css.card} onClick={onOpen}>
      <div className={css.cardTop}>
        <b>{[r.wing, r.unitNo].filter(Boolean).join(" · ")}</b>
        {r.tab === "notDone" && <span className={css.chipError}>{r.daysOverdue ? `${r.daysOverdue} ${r.daysOverdue === 1 ? "day" : "days"} overdue` : "Not done"}</span>}
        {r.tab !== "notDone" && r.rebooked && <span className={css.chipWarn}>Rebooked</span>}
      </div>
      <span className={css.muted}>{r.project}</span>
      <span>{r.customer}</span>
      <span className={css.when}>{niceDay(r.appointmentDate)} · {HALF[r.half] || ""}</span>
      <span className={css.muted}>{r.officeName}</span>
      {r.rebooked && <span className={css.muted}>Rebooked · was {niceDay(r.rebooked.fromDate)}{r.rebooked.reason ? ` (${r.rebooked.reason})` : ""}</span>}
    </button>
  );
}

function List({ session, onSignOut }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState("today");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    getRegistrations()
      .then(setData)
      .catch((err) => {
        const e = riderError(err);
        if (e.status === 401) onSignOut();
        else setError(e.message);
      })
      .finally(() => setLoading(false));
  }, [onSignOut]);

  useEffect(() => {
    load();
  }, [load]);

  const shown = (data?.registrations || []).filter((r) => r.tab === tab);
  return (
    <div className={css.page}>
      <TopBar name={session?.rider?.name} onSignOut={onSignOut} />
      <div className={css.titleRow}>
        <p className={css.pageTitle}>My registrations</p>
        <button type="button" className={css.link} disabled={loading} onClick={load}>{loading ? "Loading…" : "Refresh"}</button>
      </div>
      <div className={css.tabs} role="tablist">
        {TABS.map(([key, label]) => (
          <button key={key} type="button" role="tab" aria-selected={tab === key} className={`${css.tab} ${tab === key ? css.tabOn : ""}`} onClick={() => setTab(key)}>
            {label} <span className={css.count}>{data?.counts?.[key] ?? 0}</span>
          </button>
        ))}
      </div>
      {error && <p className={css.error} role="alert">{error}</p>}
      {!data && !error ? (
        <p className={css.empty}>Loading…</p>
      ) : shown.length === 0 ? (
        <p className={css.empty}>{tab === "today" ? "No registrations today." : tab === "upcoming" ? "No upcoming registrations." : "Nothing in Not Done."}</p>
      ) : (
        <div className={css.list}>
          {shown.map((r) => <Card key={r.slotBookingId} r={r} onOpen={() => navigate(`/rider/${r.slotBookingId}`)} />)}
        </div>
      )}
    </div>
  );
}

// Mark Registration Done pop-up (DC-63 / DC-65), in the Sales App's Agreement Done pop-up style.
// Date: today for an Upcoming job, else the appointment date. Submit = Agreement done; the upload
// goes to the Customer Portal.
const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(92vw, 64rem)",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",
};
const ACCEPTED_FILES = "image/jpeg,image/png,application/pdf";

function UploadBox({ id, label, file, onChange, error }) {
  return (
    <div>
      <div className={modalCss.InputTitle}>{label}</div>
      <Box className={`${modalCss.uploadBox} ${css.uploadBoxSmall} ${error ? modalCss.uploadBoxError : ""}`} onClick={() => document.getElementById(id).click()}>
        {file ? (
          <div className={modalCss.fileRow}>
            <span className={modalCss.fileName}>{file.name}</span>
            <span className={modalCss.removeFile} onClick={(e) => { e.stopPropagation(); onChange(null); }}>Remove</span>
          </div>
        ) : (
          <>
            <div className={modalCss.uploadImg}><FileUploadOutlinedIcon style={{ fontSize: "2.4rem", color: "#475467" }} /></div>
            <div className={modalCss.uploadLabel}>Upload here</div>
            <div className={modalCss.uploadHint}>Photo or PDF</div>
          </>
        )}
        <input hidden type="file" id={id} accept={ACCEPTED_FILES} onChange={(e) => { if (e.target.files?.[0]) onChange(e.target.files[0]); e.target.value = ""; }} />
      </Box>
      {error && <div className={modalCss.helperText}>{error}</div>}
    </div>
  );
}

function DoneModal({ d, slotBookingId, onClose, onSignOut }) {
  const navigate = useNavigate();
  const a = d.appointment;
  const [no, setNo] = useState("");
  const [date, setDate] = useState(() => dayjs(d.tab === "upcoming" ? todayKey() : a.day).toDate());
  const [indexII, setIndexII] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [fields, setFields] = useState({});
  const day = date ? dayjs(date).format("YYYY-MM-DD") : "";
  const ok = no.trim() && day && (indexII || receipt) && !busy;
  const unit = [d.booking.wing, d.booking.unitNo].filter(Boolean).join(" - ");

  async function submit() {
    setBusy(true);
    setError("");
    setFields({});
    try {
      const out = await markRegistrationDone(slotBookingId, { registrationNo: no.trim(), registrationDate: day, indexII, receipt });
      const up = indexII ? "Index II" : "Receipt";
      successTost(out.alreadyDone ? "This registration was already marked done." : `Registration done. ${up} on the Customer Portal; return the original to the Document Desk`);
      navigate("/rider");
    } catch (err) {
      const e = riderError(err);
      if (e.status === 401) onSignOut();
      else {
        setError(e.message);
        setFields(e.fields);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal open onClose={(_, reason) => reason !== "backdropClick" && !busy && onClose()} aria-labelledby="rider-done-title">
      <Box sx={MODAL_STYLE}>
        <Box className={modalCss.headerDiv}>
          <Box className={modalCss.flexRow} style={{ alignItems: "center" }}>
            <Box className={modalCss.HeaderTitle} id="rider-done-title">Mark Registration Done</Box>
            <Box ml={"auto"} onClick={() => !busy && onClose()} style={{ cursor: "pointer" }}><Close width={"1.2rem"} height={"1.2rem"} /></Box>
          </Box>
        </Box>

        <Box className={`${modalCss.bodyDiv} ${css.modalBody}`}>
          <Box className={modalCss.leadDetailsRow} style={{ marginBottom: "1.6rem" }}>
            <div className={modalCss.leadDetails}><p>Customer Name:</p><div>{d.booking.customer || "-"}</div></div>
            <div className={modalCss.leadDetails}><p>Unit:</p><div>{unit} | {d.booking.project}</div></div>
          </Box>

          <div className={css.modalGrid}>
            <div>
              <div className={modalCss.InputTitle}>Registration number<span className={modalCss.Star}> *</span></div>
              <CustomInput placeholder={"e.g. HVL18-16233-2026"} value={no} max={60} handleChange={(v) => setNo(v)} helperText={fields.registrationNo || ""} />
            </div>
            <div>
              <div className={modalCss.InputTitle}>Registration date<span className={modalCss.Star}> *</span></div>
              <DesktopDatePickerComponent value={date} maxDate={new Date()} minDate={new Date("2000-01-01")} onChangeDate={(v) => setDate(v || null)} helperText={fields.registrationDate || ""} />
            </div>
          </div>

          <div className={modalCss.InputTitle} style={{ marginTop: "1.6rem" }}>
            Index II or receipt<span className={modalCss.Star}> *</span> <span className={css.muted}>Upload at least one</span>
          </div>
          <div className={css.modalGrid}>
            <UploadBox id="riderIndexII" label="Index II" file={indexII} onChange={setIndexII} error={fields.indexII} />
            <UploadBox id="riderReceipt" label="Registration receipt" file={receipt} onChange={setReceipt} error={fields.receipt} />
          </div>
          {fields.document && <div className={modalCss.helperText}>{fields.document}</div>}

          {day && day < a.day && (
            <p className={css.noteWarn} style={{ marginTop: "1.6rem" }}>Appointment was {keyDay(a.day)}. Registered earlier: the appointment closes with this date.</p>
          )}
          <p className={css.noteMuted} style={{ marginTop: "1.2rem" }}>Office: {a.officeName}. Agreement date = registration date. The upload goes to the Customer Portal.</p>
          {error && <div className={modalCss.helperText} role="alert">{error}</div>}
        </Box>

        <Box className={modalCss.FooterDiv}>
          <Box className={modalCss.flexRow} style={{ justifyContent: "flex-end", gap: "1.2rem" }}>
            <Button
              style={{ fontSize: "1.4rem", lineHeight: "2rem", color: "#344054", backgroundColor: "#FFFFFF", borderRadius: "0.8rem", border: "1px solid #D0D5DD" }}
              padding={"0.85rem 2.6rem"} btnName={"Cancel"} clicked={() => !busy && onClose()} />
            <Button
              style={{ fontSize: "1.4rem", lineHeight: "2rem", color: "#FFFFFF", backgroundColor: "#006AFF", borderRadius: "0.8rem" }}
              padding={"0.85rem 3.2rem"} btnName={"Submit"} isLoading={busy} disable={!ok} clicked={submit} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

function Detail({ slotBookingId, onSignOut }) {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const [doneOpen, setDoneOpen] = useState(false);

  useEffect(() => {
    getRegistration(slotBookingId)
      .then(setD)
      .catch((err) => {
        const e = riderError(err);
        if (e.status === 401) onSignOut();
        else setError(e.message);
      });
  }, [slotBookingId, onSignOut]);

  const a = d?.appointment;
  return (
    <div className={css.page}>
      <TopBar name={riderToken()?.rider?.name} onSignOut={onSignOut} />
      <div className={css.titleRow}>
        <button type="button" className={css.link} onClick={() => navigate("/rider")}>‹ Back to my registrations</button>
      </div>
      {error && <p className={css.error} role="alert">{error}</p>}
      {!d && !error && <p className={css.empty}>Loading…</p>}
      {d && (
        <div className={css.list}>
          <section className={css.section}>
            <p className={css.sectionTitle}>Booking</p>
            <b>{[d.booking.wing, d.booking.unitNo].filter(Boolean).join(" · ")}{d.booking.unitType ? ` · ${d.booking.unitType}` : ""}</b>
            <span>{d.booking.project}</span>
            <span>Customer: {d.booking.customer}</span>
            {d.booking.crm && <span className={css.muted}>CRM: {d.booking.crm}</span>}
          </section>

          <section className={css.section}>
            <p className={css.sectionTitle}>Appointment</p>
            {d.tab === "notDone" && <span className={css.chipError}>Not done · appointment was {niceDay(a.date)}</span>}
            <b>{niceDay(a.date)} · {HALF[a.half] || ""}{a.halfHours ? ` (${a.halfHours})` : ""}</b>
            <span>{a.officeName}</span>
            {a.igrOfficeName && <span className={css.muted}>IGR: {a.igrOfficeName}</span>}
            {a.address && <span className={css.muted}>{a.address}</span>}
            {a.rebooked && <span className={css.muted}>Rebooked · was {niceDay(a.rebooked.fromDate)}{a.rebooked.reason ? ` (${a.rebooked.reason})` : ""}</span>}
            <div className={css.row}>
              {a.mapUrl && <a className={css.secondary} href={a.mapUrl} target="_blank" rel="noreferrer">Open map</a>}
              {a.phone && <a className={css.secondary} href={`tel:${a.phone}`}>Call office</a>}
            </div>
          </section>

          <section className={css.section}>
            <p className={css.sectionTitle}>Applicants (all attend)</p>
            {d.applicants.length === 0 && <span className={css.muted}>No applicant details.</span>}
            {d.applicants.map((p) => (
              <div key={p.no} className={css.person}>
                <b>{p.no}. {p.name}</b>
                <span className={css.muted}>{[p.gender, p.age != null ? `${p.age} yrs` : null].filter(Boolean).join(" · ")}</span>
                <span className={css.muted}>Aadhaar {p.aadhaar || "—"} · PAN {p.pan || "—"}</span>
                {p.mobile && <a className={css.callLink} href={`tel:${p.mobile}`}>Call {p.mobile}</a>}
              </div>
            ))}
          </section>

          <section className={css.section}>
            <p className={css.sectionTitle}>Carry / check</p>
            <ul className={css.carry}>
              {d.carry.items.map((t) => <li key={t}>{t}</li>)}
            </ul>
            {d.carry.grnNumber && <span className={css.muted}>GRN: {d.carry.grnNumber}</span>}
          </section>

          <button type="button" className={css.primary} onClick={() => setDoneOpen(true)}>Mark Registration Done</button>
          {doneOpen && <DoneModal d={d} slotBookingId={slotBookingId} onClose={() => setDoneOpen(false)} onSignOut={onSignOut} />}
        </div>
      )}
    </div>
  );
}

const RiderApp = () => {
  const { slotBookingId } = useParams();
  const navigate = useNavigate();
  const [session, setSession] = useState(() => riderToken());
  const signOut = useCallback(() => {
    clearRiderToken();
    setSession(null);
    navigate("/rider");
  }, [navigate]);

  if (!session) return <SignIn onSignedIn={setSession} />;
  return slotBookingId ? <Detail slotBookingId={slotBookingId} onSignOut={signOut} /> : <List session={session} onSignOut={signOut} />;
};

export default RiderApp;
